<template>
  <div
    ref="popup"
    :class="['popup', `popup_${popupName}`]"
    @keyup.esc="closePopup"
    @click="closePopup"
  >
    <div class="popup__body">
      <div class="popup__content" @click.stop>
        <button class="popup__close" @click="closePopup">
          <svg
            width="30" height="30"
            viewBox="0 0 30 30" fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              class="popup__close-icon" d="M29.1215 1.28976L15.8844 14.5268L28.7821 27.4244L27.4244 28.7821L14.5268 15.8844L1.28976 29.1215L0 27.8317L13.237 14.5947L0.271531 1.62918L1.62918 0.27153L14.5947 13.237L27.8317 0L29.1215 1.28976Z"
              fill="black"
            />
          </svg>
        </button>
        <slot name="title" />
        <slot name="content" :change-reload-status="changeReloadStatus" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'modal-wrapper',

  props: {
    popupName: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      closeWithReload: false,
    };
  },

  methods: {
    closePopup() {
      window.popupClose(this.$refs.popup);
      this.$emit('closePopup');
      if (this.closeWithReload) {
        window.location.reload();
      }
    },

    changeReloadStatus() {
      this.closeWithReload = !this.closeWithReload;
    },
  },
};
</script>

<style lang="scss" scoped>
.popup {
  &__close {
    background-color: rgba(0, 0, 0, 0);
  }

  &.popup_order-status {
    .popup__content {
      max-width: 530px;
      overflow: hidden;
    }
  }
}
</style>
